<!-- Modal Container -->

  <!-- Compact Header (1 line) -->
  <div class="flex items-center justify-between px-6 py-3 border-b header-sticky">
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <!-- Icon -->
      <div class="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 shrink-0">
        <mat-icon class="text-blue-600 text-base">account_tree</mat-icon>
      </div>

      <!-- Code Badge -->
      <span class="inline-flex items-center px-2 py-1  font-semibold bg-blue-100 text-blue-700 rounded shrink-0">
        {{ bomData.code }}
      </span>

      <!-- Name (truncated) -->
      <h2 class=" font-semibold  truncate">
        {{ bomData.name }}
      </h2>

      <!-- UoM Chip -->
      <span class="inline-flex items-center px-2 py-1 bg-gray-100 text-gray-700 rounded shrink-0 text-sm">
        {{ bomData.baseUnitOfMeasure?.code || 'N/A' }}
      </span>

      <!-- Notes Icon with Tooltip (if notes exist) -->
      <button *ngIf="bomData.notes"
              mat-icon-button
              class="shrink-0"
              [matTooltip]="bomData.notes"
              matTooltipPosition="below">
        <mat-icon class="text-gray-400 text-base">info</mat-icon>
      </button>

    </div>

    <!-- Close Button -->
    <button mat-icon-button (click)="onClose()" class="shrink-0">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Notes Display Section - Only shows when notes exist -->
  <div *ngIf="bomData.notes && bomData.notes.trim()"
       class="mx-6 mt-4 mb-2 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-3">
    <mat-icon class="text-blue-600 text-base shrink-0 mt-0.5">description</mat-icon>
    <div class="flex-1 min-w-0">
      <p class="text-xs font-semibold text-blue-900 mb-1">{{ 'BOM_MODAL.LABELS.NOTES' | t }}</p>
      <p class="text-sm text-blue-800 whitespace-pre-wrap">{{ bomData.notes }}</p>
    </div>
  </div>

  <div class="!bg-white py-4 text-md">
    <!-- TREE VIEW (solo si showAsTree = true) -->
    <mat-tree *ngIf="bomData.showAsTree" [dataSource]="dataSource" [treeControl]="treeControl">

      <!-- Leaf Node Template (no children) -->
      <mat-tree-node *matTreeNodeDef="let node" class="mb-1.5">
        <div class="flex items-start border rounded-lg !w-full pl-6">

          <!-- Icon -->
          <mat-icon [style.color]="getLevelColor(node.level)" class="text-base shrink-0">
            {{ node.icon }}
          </mat-icon>

          <!-- Content Grid -->
          <div class="flex-1 grid gap-2 items-center min-w-0"
               [ngClass]="showReturnableColumn ? 'grid-cols-3' : 'grid-cols-2'">

            <!-- Material/BOM Code + Name -->
            <div class="min-w-0">
              <p class=" font-medium "> {{ componentTypeLabel(node.componentType) }}</p>
              <p class=" font-semibold  truncate">{{ node.displayCode }}</p>
              <p class="  truncate">{{ node.displayName }}</p>

            </div>

            <!-- Cantidad Column -->
            <div class="min-w-0">
              <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.QUANTITY' | t }}</p>
              <app-unit-measure-display
                class=""
                [usedUnit]="{
                  quantity: node.soldQuantity,
                  unitId: node.soldUnitOfMeasure?._id || '',
                  unitName: node.soldUnitOfMeasure?.name || '',
                  unitAbbreviation: node.soldUnitOfMeasure?.code || ''
                }"
                [baseUnit]="{
                  quantity: node.baseQuantity,
                  unitId: node.baseUnitOfMeasure?._id || '',
                  unitName: node.baseUnitOfMeasure?.name || '',
                  unitAbbreviation: node.baseUnitOfMeasure?.code || ''
                }"
                [parallelUnit]="node.parallelUnitOfMeasure ? {
                  quantity: node.pararellQuantity,
                  unitId: node.parallelUnitOfMeasure?._id || '',
                  unitName: node.parallelUnitOfMeasure?.name || '',
                  unitAbbreviation: node.parallelUnitOfMeasure?.code || ''
                } : undefined"
                [alternalUnit]="{
                  quantity: node?.alternalQuantity,
                  unitId: node?.alternalUnitOfMeasure?._id,
                  unitName: node?.alternalUnitOfMeasure?.name,
                  unitAbbreviation: node?.alternalUnitOfMeasure?.code
                  }"
                [material]="{
                  _id: node.material?._id || node.BOM?._id || '',
                  code: node.material?.code || node.BOM?.code || '',
                  UMPActive: true
                }"
                [companyUMPActive]="true"
                [compactMode]="true"
                [decimalPlaces]="3"
                [validateFlags]="false">
              </app-unit-measure-display>
            </div>

            <!-- Is Returnable + Notes -->
            <div class="min-w-0" *ngIf="showReturnableColumn">
              <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.RETURNABLE' | t }}</p>
              <p class="" [class.text-green-600]="node.isReturnable" [class.text-gray-400]="!node.isReturnable">
                {{ formatBoolean(node.isReturnable) }}
              </p>
              <button *ngIf="node.notes"
                      mat-icon-button
                      [matTooltip]="node.notes"
                      class="w-5 h-5 -ml-1">
                <mat-icon class=" text-gray-400">info</mat-icon>
              </button>
            </div>

          </div>
        </div>
      </mat-tree-node>

      <!-- Nested Node Template (with children) -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" class="mb-1.5">
          <!-- Parent Node (with expand button) -->
          <div class="flex items-start border-2 rounded-lg"
               [class.border-purple-300]="node.hasNestedBom">

              <mat-icon mat-icon-button
                    matTreeNodeToggle  [attr.aria-label]="toggleAriaLabel(node.displayName)"
                    class=" text-base cursor-pointer">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            <!-- Icon -->
            <mat-icon [style.color]="getLevelColor(node.level)" class="text-base shrink-0">
              {{ node.icon }}
            </mat-icon>

            <!-- Content Grid (same as leaf node) -->
            <div class="flex-1 grid gap-2 items-center min-w-0"
                 [ngClass]="showReturnableColumn ? 'grid-cols-3' : 'grid-cols-2'">

              <!-- Material/BOM Code + Name -->
              <div class="min-w-0">
                <p class=" font-medium ">{{ componentTypeLabel(node.componentType) }}</p>
                <p class=" font-semibold  truncate">{{ node.displayCode }}</p>
                <p class="  truncate">{{ node.displayName }}</p>
              </div>

              <!-- Cantidad Column -->
              <div class="min-w-0">
                <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.QUANTITY' | t }}</p>
                <app-unit-measure-display
                  class=""
                  [usedUnit]="{
                    quantity: node.soldQuantity,
                    unitId: node.soldUnitOfMeasure?._id || '',
                    unitName: node.soldUnitOfMeasure?.name || '',
                    unitAbbreviation: node.soldUnitOfMeasure?.code || ''
                  }"
                  [baseUnit]="{
                    quantity: node.baseQuantity,
                    unitId: node.baseUnitOfMeasure?._id || '',
                    unitName: node.baseUnitOfMeasure?.name || '',
                    unitAbbreviation: node.baseUnitOfMeasure?.code || ''
                  }"
                  [parallelUnit]="node.parallelUnitOfMeasure ? {
                    quantity: node.pararellQuantity,
                    unitId: node.parallelUnitOfMeasure?._id || '',
                    unitName: node.parallelUnitOfMeasure?.name || '',
                    unitAbbreviation: node.parallelUnitOfMeasure?.code || ''
                  } : undefined"
                  [alternalUnit]="{
                    quantity: node?.alternalQuantity,
                    unitId: node?.alternalUnitOfMeasure?._id,
                    unitName: node?.alternalUnitOfMeasure?.name,
                    unitAbbreviation: node?.alternalUnitOfMeasure?.code
                    }"
                  [material]="{
                    _id: node.material?._id || node.BOM?._id || '',
                    code: node.material?.code || node.BOM?.code || '',
                    UMPActive: true
                  }"
                  [companyUMPActive]="true"
                  [compactMode]="true"
                  [decimalPlaces]="3"
                  [validateFlags]="false">
                </app-unit-measure-display>
              </div>

              <!-- Is Returnable + Notes -->
              <div class="min-w-0" *ngIf="showReturnableColumn">
                <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.RETURNABLE' | t }}</p>
                <p class="" [class.text-green-600]="node.isReturnable" [class.text-gray-400]="!node.isReturnable">
                  {{ formatBoolean(node.isReturnable) }}
                </p>
                <button *ngIf="node.notes"
                        mat-icon-button
                        [matTooltip]="node.notes"
                        class="w-5 h-5 -ml-1">
                  <mat-icon class=" text-gray-400">info</mat-icon>
                </button>
              </div>

            </div>
          </div>

          <!-- Children Container (nested with indentation) -->
          <div *ngIf="treeControl.isExpanded(node)" class="ml-10 mt-1">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
      </mat-nested-tree-node>

    </mat-tree>

    <!-- LIST VIEW (default cuando showAsTree = false) -->
    <div *ngIf="!bomData.showAsTree" class="flex flex-col gap-2 px-2">
      <div *ngFor="let component of listComponents"
           class="flex items-start border rounded-lg px-2">

        <!-- Icon -->
        <mat-icon class="text-blue-600 text-base shrink-0 mr-3">
          {{ component.componentType === 'BOM' ? 'folder' : 'inventory_2' }}
        </mat-icon>

        <!-- Content Grid (igual al árbol pero sin indentación) -->
        <div class="flex-1 grid gap-2 items-center min-w-0"
             [ngClass]="showReturnableColumn ? 'grid-cols-3' : 'grid-cols-2'">
          <!-- Material/BOM Code + Name -->
          <div class="min-w-0">
            <p class=" font-medium ">{{ componentTypeLabel(component.componentType) }}</p>
            <p class=" font-semibold  truncate">
              {{ component.material?.code || component.BOM?.code || component.materialBOM?.code }}
            </p>
            <p class="  truncate">
              {{ component.material?.name || component.BOM?.name || component.materialBOM?.name }}
            </p>
          </div>

          <!-- Cantidad Column -->
          <div class="min-w-0">
            <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.QUANTITY' | t }}</p>
            <app-unit-measure-display
              class=""
              [usedUnit]="{
                quantity: component.soldQuantity,
                unitId: component.soldUnitOfMeasure?._id || '',
                unitName: component.soldUnitOfMeasure?.name || '',
                unitAbbreviation: component.soldUnitOfMeasure?.code || ''
              }"
              [baseUnit]="{
                quantity: component.baseQuantity,
                unitId: component.baseUnitOfMeasure?._id || '',
                unitName: component.baseUnitOfMeasure?.name || '',
                unitAbbreviation: component.baseUnitOfMeasure?.code || ''
              }"
              [parallelUnit]="component.parallelUnitOfMeasure ? {
                quantity: component.pararellQuantity,
                unitId: component.parallelUnitOfMeasure?._id || '',
                unitName: component.parallelUnitOfMeasure?.name || '',
                unitAbbreviation: component.parallelUnitOfMeasure?.code || ''
              } : undefined"
              [alternalUnit]="{
                  quantity: node?.alternalQuantity,
                  unitId: node?.alternalUnitOfMeasure?._id,
                  unitName: node?.alternalUnitOfMeasure?.name,
                  unitAbbreviation: node?.alternalUnitOfMeasure?.code
                  }"
              [material]="{
                _id: component.material?._id || component.BOM?._id || '',
                code: component.material?.code || component.BOM?.code || '',
                UMPActive: true
              }"
              [companyUMPActive]="true"
              [compactMode]="true"
              [decimalPlaces]="3"
              [validateFlags]="false">
            </app-unit-measure-display>
          </div>

          <!-- Retornable + Notes -->
          <div class="min-w-0" *ngIf="showReturnableColumn">
            <p class=" font-medium ">{{ 'BOM_MODAL.LABELS.RETURNABLE' | t }}</p>
            <p class=""
               [class.text-green-600]="component.isReturnable"
               [class.text-gray-400]="!component.isReturnable">
              {{ formatBoolean(component.isReturnable) }}
            </p>
            <button *ngIf="component.notes"
                    mat-icon-button
                    [matTooltip]="component.notes"
                    class="w-5 h-5 -ml-1">
              <mat-icon class=" text-gray-400">info</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer (Compact) -->
  <mat-dialog-actions   class="flex justify-end gap-2 p-4">
    <button mat-button (click)="onClose()">
      {{ 'BOM_MODAL.ACTIONS.CLOSE' | t }}
    </button>
  </mat-dialog-actions>

